import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";

import { Grid, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import ShipmentContentField from "./ShipmentContentField";
import { SelectField } from "@syos-music/form";

const MUTATION = gql`
  mutation (
    $orderId: ID!
    $shipmentPurpose: CreateOrderShipmentFedex_ShipmentPurpose!
    $content: [OrderShipmentContentInput]!
  ) {
    CreateOrderShipmentFedex(
      orderId: $orderId
      shipmentPurpose: $shipmentPurpose
      content: $content
    ) {
      orderShipment {
        id
      }
    }
  }
`;

const SHIPMENT_PURPOSES = {
  SOLD: "Commercial",
  GIFT: "Cadeau",
  SAMPLE: "Échantillon",
  REPAIR_AND_RETURN: "Réparation et retour",
  PERSONAL_EFFECTS: "Effets personnels",
  NOT_SOLD: "Usage personnel",
};

export default function OrderShipmentFedexForm({ order, onSubmitted }) {
  const [createShipment] = useMutation(MUTATION);

  return (
    <Form
      mutators={{ ...arrayMutators }}
      onSubmit={async ({ shipmentPurpose, content }) =>
        createShipment({
          variables: {
            orderId: order.id,
            shipmentPurpose,
            content,
          },
        })
          .then(() => {
            onSubmitted();
          })
          .catch((err) => err)
      }
      initialValues={{
        shipmentPurpose: "SOLD",
        content: ShipmentContentField.getInitialValue(order),
      }}
      keepDirtyOnReinitialize
    >
      {({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} noValidate autoComplete="off">
          <Grid container>
            <Grid item xs={12}>
              <SelectField
                name="shipmentPurpose"
                required
                label="Nature de l’envoi"
              >
                {Object.entries(SHIPMENT_PURPOSES).map(([value, label]) => (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                ))}
              </SelectField>
            </Grid>

            <Grid item xs={12}>
              <ShipmentContentField name="content" order={order} />
            </Grid>

            <Grid item xs={12} align="right">
              <LoadingButton type="submit" loading={submitting}>
                Valider
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
}

OrderShipmentFedexForm.fragments = {
  order: gql`
    fragment OrderShipmentFedexForm_order on Order {
      id
      ...ShipmentContentField_Order
    }

    ${ShipmentContentField.fragments.order}
  `,
};
